import API from "../../../API/API";

const api = new API();
  const endPoints = "signup";
 
export const postSignUpApi = async (data) => {
  return new Promise(async (resolve, reject) =>{
    try {
        const result = await api.post(endPoints, data);
        resolve(result);
      
    }catch (error) {
      console.error("API error", error);
      reject(error);
    }
  })
}